module.exports = __webpack_public_path__ + "img/ierp_logo3a.a4b097e2.png";